import React from 'react'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexYogaPageHeader = ({ page, ...props }: StylesProps) => {
  return (
    <div className="flex flex-col space-y-fluid-4 px-fluid-4 pb-fluid-4 pt-fluid-16">
      <HeaderLogo
        media={page?.logoMedia}
        {...props}
        className="rounded-[38px]"
        sizeClassName="size-fluid-28"
        size={112}
      />

      <HeaderName
        name={page?.name}
        {...props}
        className="text-fluid-5xl text-page-text"
      />

      <HeaderDescription
        description={page?.description}
        {...props}
        className="text-fluid-lg text-page-text"
      />

      <HeaderSocialIcons
        socialIcons={page?.socialIcons}
        {...props}
        primaryClassName="p-fluid-6 page-header-primary-button min-w-fluid-64 rounded-page-widget!"
        showPrimaryLabel
        type="PRIMARY"
      />

      <HeaderBanner
        media={page?.bannerMedia}
        className="aspect-video rounded-page-widget"
        {...props}
      />

      <HeaderSocialIcons
        socialIcons={page?.socialIcons}
        {...props}
        className="page-header-block ft-widget-wrapper justify-center rounded-page-widget p-fluid-2 pb-fluid-0"
        secondaryClassName="p-fluid-3 page-header-secondary-button rounded-page-widget-2!"
        type="SECONDARY"
      />
    </div>
  )
}
